import SubscribeForm from "@/components/feature/SubscribeForm";

export default function SubscribeSection() {
  return (
    <section aria-label="订阅今日速递" className="mx-auto max-w-[1400px] px-4 md:px-6">
      <div className="overflow-hidden rounded-lg border border-primary-200 bg-primary-50">
        <div className="grid grid-cols-1 lg:grid-cols-[1.1fr_1fr]">
          <div className="p-6 md:p-10">
            <span className="flex w-fit items-center gap-2 rounded-full bg-primary-500 px-3 py-1 text-xs font-medium text-background-50">
              <i className="ri-notification-3-fill" />
              今日速递
            </span>
            <h2 className="mt-4 font-serif-cn text-2xl font-bold leading-snug text-foreground-950 md:text-3xl">
              不想一条条翻？
              <br />
              让今天的热点自己找上门
            </h2>
            <p className="mt-3 max-w-lg text-sm leading-relaxed text-foreground-600">
              订阅后每天早晚各收到一封速递，把最新爆料、即时快讯与突发消息按重要性排好，一分钟看完当天重点。
            </p>
            <ul className="mt-5 space-y-2 text-sm text-foreground-700">
              <li className="flex items-center gap-2">
                <i className="ri-check-line text-primary-500" />
                早晚两封，不打扰、不刷屏
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-check-line text-primary-500" />
                按栏目筛选，只看你关心的方向
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-check-line text-primary-500" />
                随时可退订，邮箱不会被转交他人
              </li>
            </ul>
          </div>
          <div className="border-t border-primary-200 bg-background-50 p-6 md:p-10 lg:border-l lg:border-t-0">
            <p className="font-serif-cn text-lg font-semibold text-foreground-950">订阅 51cg网 速递</p>
            <p className="mt-1.5 mb-4 text-sm text-foreground-600">
              填写邮箱并选择你想关注的栏目即可。
            </p>
            <SubscribeForm />
          </div>
        </div>
      </div>
    </section>
  );
}